<style scoped>
  .initModal {
    padding: 0 12px;
    text-align: center;
  }
  #findpasswordcontent{
    margin:0 auto;
    text-align: center;
    width: 500px;
  }
  .img-yzm{ width:100px;height:34px;margin: 1px;vertical-align: middle;}
</style>
<template>
  <div>
      <div id="findpasswordcontent" width="400">
        <div>
          <Tabs value="emailFindPassport" :animated="false">
            <TabPane label="重置密码" name="emailFindPassport">
              <Form ref="emailFormParams" :model="emailFormParams" :rules="emailRuleValidate" class="initModal">
                <FormItem prop="email">
                  <Input v-model.trim="emailFormParams.email" placeholder="邮箱地址" style="width:323px;" @on-blur="emailValid" readonly></Input>
                </FormItem>
                <FormItem prop="password">
                  <Input v-model.trim="emailFormParams.password" type="password" placeholder="密码长度应介于6~16位之间" style="width:323px;"></Input>
                </FormItem>
                <FormItem prop="confirmPassword">
                  <Input v-model.trim="emailFormParams.confirmPassword" type="password" placeholder="再次确认密码" style="width:323px;"></Input>
                </FormItem>
              </Form>
            </TabPane>
          </Tabs>
        </div>
        <div style="padding:0 39px;">
          <Button type="primary" size="large" long @click="submitBtn">提交</Button>
        </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin],
  components: {},
  data () {
    let self = this;
    return {
      emailFormParams: {
        email: this.$route.query.e, // 邮箱
        password:'',// 密码
        confirmPassword:''//确认密码
      },
      emailRuleValidate: {
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: self.validatePassword(), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次确认密码', trigger: 'blur' },
          { validator: self.validateMobileConfirmPwd(), trigger: 'blur' }
        ]
      },
      disabledMobile: false,
      mobileTime: 0, // 获取手机验证码初始0
    };
  },
  methods: {
    Login () {
      let origin = window.location.origin;
      let url = origin + '/logisicsProvider.html#/';
      window.location.href = url;
    },
    // 密码格式校验
    validatePassword () {
      let validatePassword = function (rule, value, callback) {
        if (value.length < 6 || value.length > 16) {
          callback(new Error('密码长度应介于6~16位之间'));
        } else {
          callback();
        }
      };
      return validatePassword;
    },
    validateMobileConfirmPwd () {
      let v = this;
      let validateMobileConfirmPwd = function (rule, value, callback) {
        if (value !== v.phoneFormParams.password) {
          callback(new Error('确认密码和密码不一致'));
        } else {
          callback();
        }
      };
      return validateMobileConfirmPwd;
    },
    // 重置密码
    submitBtn () {
      let v = this;
      var emailObj = {
          email: v.emailFormParams.email, // 邮箱地址
          password: v.emailFormParams.password, // 密码
          checkCode: this.$route.query.c,
          registerType: 'email'
        };
        v.$refs['emailFormParams'].validate((valid) => {
          if (valid) {
            v.axios.post(api.resetPassword, emailObj)
            .then(res => {
                if (res.data.code === 0) {
                  v.$Message.success('提交成功');
                  v.Login();
                } else {
                  v.$Message.error(res.data.message);
                }
            });
          } else {
            v.$Message.error('请填写必填项');
          }
        });
    }
  },
  computed: {

  },
  watch: {
  }
};
</script>



// WEBPACK FOOTER //
// src/views/index/components/findpasswordForEmail.vue